import store from '@Store';
import { closeDialog, updateDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfFindPreparationsSimilaritySearchDialog } from '@Containers/FindPreparations/SimilatiySearch/constants';

// To prevent circular dependencies between actions <-> FindPreparationsService
export const openFindPreparationsSimilaritySearchDialog = ({ substance, context, originalDatabaseId }) => {
  return updateDialog({
    id: typeOfFindPreparationsSimilaritySearchDialog,
    typeOfFindPreparationsSimilaritySearchDialog,
    dialogType: typeOfFindPreparationsSimilaritySearchDialog,
    substance,
    context,
    originalDatabaseId,
  });
};

export const dispatchOpenFindPreparationsSimilaritySearchDialog = (...args) =>
  store.dispatch(openFindPreparationsSimilaritySearchDialog(...args));

export const closeFindPreparationsSimilaritySearchDialog = () => {
  return closeDialog({ id: typeOfFindPreparationsSimilaritySearchDialog });
};
